import { Business } from "../features/business/types";

export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const dummyBusinesses: Business[] = [
  {
    _id: "1",
    name: "Fresh Cuts Barber Shop",
    type: "Barber",
    address: "MG Road, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400",
    queues: [
      { _id: "q1", name: "Walk-in", mode: "fifo" },
      { _id: "q2", name: "Appointments", mode: "slot-based" },
    ],
  },
  {
    _id: "2",
    name: "City Health Clinic",
    type: "Clinic",
    address: "HSR Layout, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1580281658629-8cbb59f01f2a?w=400",
    queues: [{ _id: "q3", name: "General Consultation", mode: "fifo" }],
  },
  {
    _id: "3",
    name: "QuickFix Mobile Repair",
    type: "Repair Shop",
    address: "Indiranagar, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=600&q=80",
    queues: [{ _id: "q4", name: "Walk-in Repairs", mode: "fifo" }],
  },
  {
    _id: "4",
    name: "Glow & Shine Beauty Salon",
    type: "Salon",
    address: "Koramangala 4th Block, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=400",
    queues: [
      { _id: "q5", name: "Walk-in", mode: "fifo" },
      { _id: "q6", name: "Bridal Appointments", mode: "slot-based" },
    ],
  },
  {
    _id: "5",
    name: "Happy Kids Dental Clinic",
    type: "Dental Clinic",
    address: "BTM Layout, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1629909613654-28e377c37d42?w=400",
    queues: [
      { _id: "q7", name: "General Checkup", mode: "fifo" },
      { _id: "q8", name: "Appointments", mode: "slot-based" },
    ],
  },
  {
    _id: "6",
    name: "GearUp Bike Service",
    type: "Bike Service Center",
    address: "Whitefield Main Road, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1523966211575-eb4a6d11e6c7?w=400",
    queues: [
      { _id: "q9", name: "Quick Service", mode: "fifo" },
      { _id: "q10", name: "Full Service", mode: "fifo" },
    ],
  },
  {
    _id: "7",
    name: "GreenLeaf Spa & Wellness",
    type: "Spa",
    address: "JP Nagar, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1556228578-480a20f054d3?w=400",
    queues: [
      { _id: "q11", name: "Walk-in", mode: "fifo" },
      { _id: "q12", name: "Therapy Sessions", mode: "slot-based" },
    ],
  },
  {
    _id: "8",
    name: "LensCraft Opticals",
    type: "Optical Store",
    address: "Banashankari Stage-2, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400",
    queues: [
      { _id: "q13", name: "Eye Test", mode: "fifo" },
      { _id: "q14", name: "Consultation", mode: "slot-based" },
    ],
  },
  {
    _id: "9",
    name: "PetCare Veterinary Clinic",
    type: "Vet Clinic",
    address: "Electronic City Phase-1, Bangalore",
    logoUrl: "https://images.unsplash.com/photo-1516728778615-2d590ea1856f?w=400",
    queues: [
      { _id: "q15", name: "Walk-in", mode: "fifo" },
      { _id: "q16", name: "Surgery Appointments", mode: "slot-based" },
    ],
  },
];

export const providersMock: Record<string, { id: number; name: string; speciality: string; waitTime: string; token: number }[]> = {
  doctor: [
    { id: 1, name: 'Dr. Ayesha Khan', speciality: 'Dermatologist', waitTime: '15 mins', token: 101 },
    { id: 2, name: 'Dr. R. Srivastava', speciality: 'Cardiologist', waitTime: '25 mins', token: 102 },
  ],
  barber: [
    { id: 3, name: 'Mr. Barber Singh', speciality: 'Haircut', waitTime: '10 mins', token: 201 },
  ],
  salon: [
    { id: 4, name: 'Ms. Beauty Sharma', speciality: 'Facial', waitTime: '20 mins', token: 301 },
  ],
  mechanic: [
    { id: 5, name: 'Mr. Fixit', speciality: 'Car Repair', waitTime: '30 mins', token: 401 },
  ],
  consultant: [
    { id: 6, name: 'Ms. Advice Patel', speciality: 'Business Consulting', waitTime: '40 mins', token: 501 },
  ],
};

export const categoryIcons: Record<string, string> = {
  healthcare: '🏥',
  personal_care: '💇',
  home_service: '🏠',
  food_dining: '🍽️',
  automotive: '🚗',
  fitness_sports: '💪',
};


